(() => {
  const DESKTOP_QUERY = "(min-width: 991px)";
  const STYLE_ID = "atc-collection-desktop-style";

  function isDesktop() {
    return window.matchMedia(DESKTOP_QUERY).matches;
  }

  function applyStyle() {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent = [
      "@media screen and (min-width: 991px) {",
      "  .ns-product .ns-media-wrap:hover .ns-product-atc {",
      "    display: none !important;",
      "    visibility: hidden !important;",
      "    opacity: 0 !important;",
      "    height: 0 !important;",
      "  }",
      "}",
    ].join("\n");
    document.head.appendChild(style);
  }

  function clearActive() {
    document.querySelectorAll(".ns-product .ns-atc-wrap.ns-active").forEach((el) => {
      el.classList.remove("ns-active");
    });
  }

  function onHover(event, add) {
    if (!isDesktop()) return;
    const mediaWrap = event.target.closest(".ns-media-wrap");
    if (!mediaWrap) return;
    if (!add && mediaWrap.contains(event.relatedTarget)) return;
    const product = mediaWrap.closest(".ns-product");
    if (!product) return;
    const atcWrap = product.querySelector(".ns-atc-wrap");
    if (atcWrap) atcWrap.classList.toggle("ns-active", add);
  }

  function initDesktop() {
    applyStyle();

    document.addEventListener("mouseover", (e) => onHover(e, true), { passive: true });
    document.addEventListener("mouseout", (e) => onHover(e, false), { passive: true });

    const media = window.matchMedia(DESKTOP_QUERY);
    const onChange = () => {
      if (!media.matches) clearActive();
    };
    if (media.addEventListener) media.addEventListener("change", onChange);
    else media.addListener(onChange);

    if (!media.matches) clearActive();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initDesktop);
  } else {
    initDesktop();
  }
})();
